import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    templateId: {
      title: 'Wzór',
      type: 'number',
      fieldRequired: true
    },
    data: {
      title: 'Dane',
      type: 'string',
      fieldRequired: false
    },
    description: {
      title: 'Dodatkowy opis',
      type: 'string',
      fieldRequired: false
    },
    interpretation: {
      title: 'Opis procedury',
      type: 'string',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
